import React, { useState } from 'react';

/**
 * Klikalne pole (SKU / EAN / nr oferty) — kopiuje wartosc do schowka
 * i pokazuje chwilowe potwierdzenie "✓ Skopiowano" w miejscu.
 * label = etykieta ("SKU", "EAN", "nr"), value = wartosc do skopiowania.
 */
export default function CopyableField({ label, value, muted, hideLabel }: { label: string; value: string; muted?: boolean; hideLabel?: boolean }) {
  const [copied, setCopied] = useState(false);

  const doCopy = (e: React.MouseEvent) => {
    e.stopPropagation();  // nie otwieraj edycji/wiersza
    const text = String(value);
    const done = () => { setCopied(true); setTimeout(() => setCopied(false), 1200); };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => fallbackCopy(text, done));
      } else {
        fallbackCopy(text, done);
      }
    } catch (err) {
      fallbackCopy(text, done);
    }
  };

  const fallbackCopy = (text: string, done: () => void) => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      done();
    } catch (e) { /* nic */ }
  };

  return (
    <span
      onClick={doCopy}
      title="Kliknij, aby skopiować"
      style={{
        marginRight: 8,
        cursor: 'pointer',
        color: copied ? '#15803d' : (muted ? '#9ca3af' : undefined),
        textDecoration: 'underline dotted',
        textUnderlineOffset: 2,
        userSelect: 'none',
      }}
    >
      {copied ? '✓ Skopiowano' : (hideLabel ? value : <>{label}: {value}</>)}
    </span>
  );
}
